import { Component, OnInit } from '@angular/core';
import { OurHostsService } from '../../common/our-hosts/our-hosts.service';

@Component({
    selector: 'app-our-hosts-page',
    templateUrl: './our-hosts-page.component.html',
    styleUrls: ['./our-hosts-page.component.scss']
})
export class OurHostsPageComponent implements OnInit {

    public data: any;

    constructor(
        private content: OurHostsService
    ) {
        this.content.getData().subscribe((data: any) => {
            this.data = data.data.attributes;
        });
    }

    ngOnInit(): void {}

}